module.exports = __webpack_public_path__ + "static/img/dress_yupei_default.2200b073.png";